module.exports = __webpack_public_path__ + "static/img/explode.eb1b2873.png";